import { Box, Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams, Navigate } from 'react-router-dom'
import { SpecOptionForm } from '@/components/forms/SpecOptionForm'
import { useThemeColors } from '@/hooks/useThemeColors'
import { getSpecOptionType } from '@/pages/AssetConfiguration/specOptionTypes'
import { AssetCatalogShell } from '@/components/assetCatalog/AssetCatalogShell'
import { useAssetCatalogPaths } from '@/hooks/useAssetCatalogPaths'

export default function SpecOptionCreatePage() {
  const { specType } = useParams<{ specType: string }>()
  const config = getSpecOptionType(specType)
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { path } = useAssetCatalogPaths()

  if (!config) {
    return <Navigate to={path('overview')} replace />
  }

  const handleDone = () => navigate(path(`spec/${config.slug}`))

  return (
    <AssetCatalogShell fillHeight={false}>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Box minW={0} display="flex" flexDirection="column" overflow="hidden" flex="1">
          <Card h="full" display="flex" flexDirection="column">
            <CardHeader flexShrink={0}>
              <Heading size="md">Create {config.label}</Heading>
              <Text fontSize="sm" color={colors.text} mt={1}>
                Add a new {config.label.toLowerCase()} option for store assets
              </Text>
            </CardHeader>
            <CardBody overflowY="auto" flex="1" minH={0}>
              <SpecOptionForm config={config} onSuccess={handleDone} onCancel={handleDone} />
            </CardBody>
          </Card>
        </Box>
      </Box>
    </AssetCatalogShell>
  )
}
